document.addEventListener('DOMContentLoaded', function () {
  var openBtn = document.querySelector('[data-menu-open]');
  var closeBtn = document.querySelector('[data-menu-close]');
  var drawer = document.querySelector('[data-menu-drawer]');

  if (openBtn && drawer) {
    openBtn.addEventListener('click', function () {
      drawer.hidden = false;
      document.body.style.overflow = 'hidden';
    });
  }
  if (closeBtn && drawer) {
    closeBtn.addEventListener('click', function () {
      drawer.hidden = true;
      document.body.style.overflow = '';
    });
  }

  // Product page: gallery thumbnail swap
  var thumbs = document.querySelectorAll('[data-gallery-thumb]');
  var mainMedia = document.querySelector('[data-gallery-main]');
  if (thumbs.length && mainMedia) {
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var inner = thumb.querySelector('img, video');
        if (!inner) return;
        var clone = inner.cloneNode(true);
        if (clone.tagName === 'IMG') {
          clone.src = clone.src.replace(/width=\d+/, 'width=1400');
        }
        mainMedia.innerHTML = '';
        clone.classList.add('product-page__media-el');
        mainMedia.appendChild(clone);
        thumbs.forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
      });
    });
  }

  // Product page: variant selection updates hidden id + displayed price
  var variantDataEl = document.querySelector('[data-variant-data]');
  var variantIdInput = document.querySelector('[data-variant-id]');
  var priceEl = document.querySelector('[data-price] .product-page__price-main');
  var priceCompareEl = document.querySelector('[data-price-compare]');
  var optionInputs = document.querySelectorAll('[data-option-input]');
  if (variantDataEl && variantIdInput && optionInputs.length) {
    var variants = [];
    try { variants = JSON.parse(variantDataEl.textContent); } catch (e) { variants = []; }

    function currentSelections() {
      var positions = {};
      optionInputs.forEach(function (input) {
        if (input.checked) { positions[input.dataset.optionPosition] = input.value; }
      });
      var ordered = Object.keys(positions).sort().map(function (k) { return positions[k]; });
      return ordered;
    }

    function updateVariant() {
      var selected = currentSelections();
      var match = variants.find(function (v) {
        return v.options.length === selected.length && v.options.every(function (o, i) { return o === selected[i]; });
      });
      if (match) {
        variantIdInput.value = match.id;
        if (priceEl) {
          priceEl.textContent = '€' + (match.price / 100).toFixed(2).replace('.', ',').replace(/,00$/, '');
        }
        if (priceCompareEl) {
          if (match.compareAtPrice && match.compareAtPrice > match.price) {
            priceCompareEl.textContent = '€' + (match.compareAtPrice / 100).toFixed(2).replace('.', ',').replace(/,00$/, '');
            priceCompareEl.style.display = '';
          } else {
            priceCompareEl.style.display = 'none';
          }
        }
      }
    }

    optionInputs.forEach(function (input) { input.addEventListener('change', updateVariant); });
  }

  // Subtle fade-in reveal for sections as they enter the viewport.
  if ('IntersectionObserver' in window) {
    var targets = document.querySelectorAll('main > section');
    targets.forEach(function (el) { el.style.opacity = '0'; el.style.transform = 'translateY(12px)'; el.style.transition = 'opacity .6s ease, transform .6s ease'; });
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.style.opacity = '1';
          entry.target.style.transform = 'translateY(0)';
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });
    targets.forEach(function (el) { observer.observe(el); });
  }
});
